export default __webpack_public_path__ + "static/media/img10.20c70684.jpg";